var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"app"}},[_c('TheHeader'),_c('div',{staticClass:"page"},[_c('div',{staticClass:"page__wrapper"},[_c('router-view')],1)]),_c('TheFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }